import { render } from "./module.vue?vue&type=template&id=8b724a12&scoped=true"
import script from "./module.vue?vue&type=script&lang=js"
export * from "./module.vue?vue&type=script&lang=js"

import "./module.vue?vue&type=style&index=0&id=8b724a12&scoped=true&lang=less"

import exportComponent from "D:\\A-daima\\前端\\前台\\前台\\nonferrous_metals\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b724a12"]])

export default __exports__